import React from 'react';
import { Container } from './ui/Container';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-12 border-t border-gray-800" data-id="element-137">
      <Container data-id="element-138">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8" data-id="element-139">
          <div className="flex items-center space-x-2 mb-4 md:mb-0" data-id="element-140">
            <img src="https://cdn.magicpatterns.com/uploads/j7d4EdH3Rp1gzCoto8E26y/imgi_1_1746975280-SnoreStop™.png" alt="SnoreStop Logo" className="h-8 brightness-0 invert" data-id="element-141" />
          </div>
          <div className="flex space-x-6 text-sm" data-id="element-142">
            <a href="#" className="hover:text-white transition-colors" data-id="element-143">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-144">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-145">
              Contact Us
            </a>
          </div>
        </div>

        <div className="text-xs text-gray-500 text-center max-w-3xl mx-auto leading-relaxed" data-id="element-146">
          <p className="mb-4" data-id="element-147">
            SnoreStop™ is designed to help reduce snoring by positioning the
            jaw to open airways. Individual results may vary. This product is
            not intended to diagnose, treat, cure, or prevent any disease.
            Consult a healthcare professional if you have concerns about sleep
            apnea or other sleep disorders.
          </p>
          <p data-id="element-148">
            &copy; {new Date().getFullYear()} SnoreStop™. All rights reserved.
          </p>
        </div>
      </Container>
    </footer>;
}